// extracted by extract-css-chunks-webpack-plugin
module.exports = {"payment-error":"error-message__payment-error___2fyC5","paymentError":"error-message__payment-error___2fyC5","description":"error-message__description___Q3X-t","nowrap":"error-message__nowrap___2vsEe"};
    if(module.hot) {
      // 1631577356731
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  